import { teamReaderKey } from "@mattoboard/schemas";
import type { TeamsInterface } from "ts-interfaces";
import { getDisplayName } from "../utils/ShareResourceUtils";

// "Lena", "Lena and Tom", "Lena, Tom and Mo".
export const joinNames = (names: string[]) =>
  names.length > 1
    ? `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`
    : names[0] ?? "";

export const memberName = (roster: TeamsInterface[] | null | undefined, uid: string) => {
  const m = roster?.find((r) => r.uid === uid);
  return m ? getDisplayName(m) : null;
};

// Who a project's items are shared with, from its derived readers, leaving
// out `me`: "everyone at Studio", "Lena and Tom", or null when nobody else.
export const projectAudience = (
  project: { design_firm_id?: string | null; readers?: unknown } | null | undefined,
  me: string,
  roster: TeamsInterface[] | null | undefined,
  firmName?: string | null,
) => {
  const firm = project?.design_firm_id;
  if (!firm) return null;
  const readers = Array.isArray(project.readers) ? (project.readers as string[]) : [];
  const key = teamReaderKey(firm);
  if (readers.includes(key)) return `everyone at ${firmName || "the team"}`;
  const others = readers.filter((u) => u !== me && u !== key);
  if (!others.length) return null;
  const known = others.map((u) => memberName(roster, u)).filter((n): n is string => !!n);
  const unknown = others.length - known.length;
  return joinNames([
    ...known,
    ...(unknown ? [`${unknown} other teammate${unknown === 1 ? "" : "s"}`] : []),
  ]);
};
